import {
  Box,
  CircularProgress,
  styled,
  Stack,
  Typography,
} from "@mui/material";
import { useIsAuthenticated } from "react-auth-kit";
import { useNavigate } from "react-router";

function LoadingPaper(props) {
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  const StyleOverrides = styled("div")({
    ".MuiStack-root": {
      padding: "2rem",
      display: "block",
    },
  });

  // navigate to login if not authenticated
  // if the user is on a loaded page and tries to get to another one,
  // this will be triggered before LoadingError, which takes 3 retries (tbc)
  if (!isAuthenticated()) {
    navigate("/login");
    return (
      <>
        <Typography>
          Sessione scaduta! Reindirizzamento alla pagina di login...
        </Typography>
      </>
    );
  }

  return (
    <StyleOverrides>
      <Box
        sx={{
          padding: "5%",
          textAlign: "center",
          margin: "5%",
        }}
      >
        <Stack direction={"column"} spacing={4} sx={{ alignItems: "center" }}>
          <CircularProgress />
          <br />
          <Typography fontStyle={"italic"}>Loading...</Typography>
        </Stack>
      </Box>
    </StyleOverrides>
  );
}

export default LoadingPaper;
